import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { VoyadoTransactionsModalComponent } from '../../shared/modal-windows/voyado-transactions-modal/voyado-transactions-modal.component';
import { VoyadoMessagesModalComponent } from '../../shared/modal-windows/voyado-messages-modal/voyado-messages-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';
import { VoyadoCrmService } from 'src/app/core/services/voyado-crm.service';
import { VoyadoContactOverview } from '../../core/models/voyado-contact-overview.model';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../../sb-tools/typescript/components/loader/loader.component';
import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-voyado',
    templateUrl: './voyado.component.html',
    styleUrls: ['./voyado.component.scss'],
    providers: [],
    imports: [TranslateModule, LoaderComponent, DecimalPipe, DatePipe],
})
export class VoyadoComponent implements OnInit, OnDestroy {
    @Input() email: string;
    data: VoyadoContactOverview;
    isLoaded = false;
    isFound = false;
    private unsubscriber = new Subject<void>();

    constructor(
        private voyadoCrmService: VoyadoCrmService,
        private bsModalService: BsModalService,
    ) {}

    ngOnInit() {
        this.voyadoCrmService
            .getContactOverview(this.email)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(
                (data: VoyadoContactOverview) => {
                    if (data) {
                        this.isFound = true;
                    }
                    this.data = data;
                    this.isLoaded = true;
                },
                () => {
                    this.isFound = false;
                    this.isLoaded = true;
                },
            );
    }

    openVoyadoTransactionsModal() {
        const initialState = {
            contactId: this.data.id,
        };

        this.bsModalService.show(VoyadoTransactionsModalComponent, {
            initialState,
            ignoreBackdropClick: true,
            class: 'modal-xl',
        });
    }

    openVoyadoMessagesModal() {
        const initialState = {
            contactId: this.data.id,
        };

        this.bsModalService.show(VoyadoMessagesModalComponent, {
            initialState,
            ignoreBackdropClick: true,
            class: 'modal-xl',
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
